import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

import {
    IBookInvitePreview,
}                               from '../interfaces';

const getBookInvitePreview = async ({
    recipientEmail,
    recipientName,
    inviteMessage,
    gifterDisplayName,
    gifterEmail,
}: {
    recipientEmail?: string,
    recipientName?: string,
    inviteMessage?: string,
    gifterDisplayName?: string,
    gifterEmail?: string,
}): Promise<IBookInvitePreview> => {
    const functions = getFunctions();
    const callable = httpsCallable<
        {
            recipientEmail?: string,
            recipientName?: string,
            inviteMessage?: string,
            gifterDisplayName?: string,
            gifterEmail?: string,
        },
        IBookInvitePreview
    >(
        functions,
        'getBookInvitePreview',
    );
    return callable({
        recipientEmail,
        recipientName,
        inviteMessage,
        gifterDisplayName,
        gifterEmail,
    }).then((result) => result.data as IBookInvitePreview);
};

export default getBookInvitePreview;
